export default "__VITE_ASSET__CljHN1Xs__"